<template>
	<div id="eventsMainTemplate" class="screenSize client" >
		<div id="previously" v-if="showBackButton" v-on:click="backButton"></div>
		<hamburger v-bind:languagesSettings="languagesSettings" v-bind:api="api" v-bind:conf="generalConf"  v-bind:view="steps.current" v-on:hamburgerEvent="hamburgerEvent" v-bind:class="displayMenu ? 'selected' : ''"></hamburger>
		<div id="overlay" v-on:click="displayMenu = !displayMenu" v-bind:class="displayMenu ? 'selected' : ''"></div>
		<div id="orientation">
			<form>
				<h2>{{fields[languagesSettings.lang].landscape}}</h2>
				<img src="../assets/images/landscape_lock.svg">
			</form>
		</div>
		<header>
			<img v-bind:src="clientLogo" alt="logo remote">
			<div id="hamburger" v-on:click="displayMenu = !displayMenu" v-bind:class="displayMenu ? 'selected' : ''">
				<span></span>
				<span></span>
				<span></span>
			</div>
		</header>
		<router-view v-on:newEventSelected="updateCurrentSession" v-on:validateStep="updateStep" v-on:checkStep="checkStep" v-bind:events="events" v-bind:currentSession="currentSession" v-bind:properties="steps.properties" v-bind:api="api" v-bind:lang="languagesSettings.lang" v-bind:templateIndex="steps.index"></router-view>
		<div id="background-remote">
		</div>
	</div>
</template>

<script>
import apiConf from 'apiConf';
import lib from '@/libs/main.js';
import genId from '@/libs/randomIds.js';
import hamburger from '@/components/hamburger.vue';

window.addEventListener('online', lib.askSyncData);

const DEFAULT_TEMPLATES_KEY = 'templates';

function logOut() {
	var self = this;
	localStorage.clear();
	self.api.logout().finally(() => self.$router.push({name : 'loginPage'}));
}

function addCssSheet(client) {
	let sheet = document.getElementById('clientCss');
	var scripts = document.getElementsByTagName('script');
	var css_prefix = '';
	let prefix_reg = /app(\..*?)?\.js$/;
	for(let i = 0; i < scripts.length; ++i) {
		const match = scripts[i].src.match(prefix_reg);
		if(match && match.length == 2 && match[1]) {css_prefix = match[1]; break;}
	}
	const url = apiConf.css + client + css_prefix;

	if (!sheet){
		let head  = document.getElementsByTagName('head')[0];
		let link  = document.createElement('link');
		link.id   = 'clientCss';
		link.rel  = 'stylesheet';
		link.type = 'text/css';
		link.href = url;
		link.media = 'all';
		head.appendChild(link);
	} else if(sheet.href != url) sheet.href = url;
}

function loadStepsList(event) {
	if(event.source && Array.isArray(this.storedConf[event.source + '_templates'])) {
		const templateKey = event.source + '_templates';
		this.steps.templatesKey = templateKey;
		this.steps.list = this.storedConf[templateKey];
	} else {
		this.steps.templatesKey = DEFAULT_TEMPLATES_KEY;
		this.steps.list = this.storedConf[DEFAULT_TEMPLATES_KEY];
	}
}

function goToNextStep(nextStep) {
	if(!Array.isArray(this.steps.list) || !this.steps.list.length) loadStepsList.call(this, this.currentSession.event);
	this.steps.properties = this.steps.list[nextStep].properties || {};
	this.steps.current = this.steps.list[nextStep].name;
	this.steps.index = nextStep;
	this.$router.push({name : this.steps.list[nextStep].name});
}

export default {
	name: 'eventsMainTemplate',
	data() {
		return {
			languagesSettings : {
				lang : 'fr',
				defaultLang : 'fr',
				langList : ['fr', 'en']
			},
			displayMenu : false,
			currentSession : {
				event : {
					_id : null,
					name : null,
					startDate : null,
					endDate : null,
					source : null
				},
				stepsResults : {},
				goToPreviouslPage : null
			},
			steps : {
				current : '',
				list : [],
				properties : {},
				index : 0,
				templatesKey : DEFAULT_TEMPLATES_KEY
			},
			events : [],
			storedConf : {},
			generalConf : {},
			fields : {
				fr : {
					landscape : 'Merci de repasser en mode portrait'
				},
				en : {
					landscape : 'Please go back into portrait mode'
				}
			}
		};
	},
	props : ['api'],
	components : {
		hamburger,
	},
	methods : {
		updateCurrentSession : function(data) {
			this.currentSession.event = data;
			this.currentSession.stepsResults = {};
			loadStepsList.call(this, data);
            localStorage.removeItem('stepsResults');
			try{localStorage.setItem("currentEvent", JSON.stringify(data))}catch(e){console.log(e);}
			goToNextStep.call(this, 0);
		},
		updateStep : function(stepName, data) {
			if(!data) return;
			this.currentSession.stepsResults[stepName + '_' + this.steps.index] = data;
			try{
				localStorage.setItem('stepsResults', JSON.stringify(this.currentSession.stepsResults));
			}catch(e){console.log(e);}
			var nextStep = this.steps.index + 1;
			let self = this;
			if(nextStep >= this.steps.list.length) {
				nextStep = 0;
				let results = JSON.parse(JSON.stringify(this.currentSession.stepsResults));
				let event = JSON.parse(JSON.stringify(this.currentSession.event));
				results.lang = this.languagesSettings.lang;
				this.api.addNewApplication(event, results, genId())
				.then((applicationSent) => {
					this.currentSession.stepsResults = {};
					localStorage.removeItem('stepsResults');
					goToNextStep.call(self, 0);
					lib.askSyncData(); //Ask sync last
				}).catch(e => {
					console.log(e);
					logOut.call(self);
				});
			} else goToNextStep.call(this, nextStep);
		},
		hamburgerEvent : function(action) {
			if(action == "cancelApplication") {
				this.currentSession.stepsResults = {};
				localStorage.removeItem('stepsResults');
				goToNextStep.call(this, 0);
			} else if(action == "homeButton") {
				localStorage.removeItem("currentEvent");
				localStorage.removeItem("stepsResults");
				this.$router.push({name: "newEvent"});
			}
			this.displayMenu = false;
		},
		checkStep : function(tplName) {
			let name = this.steps.current;
			if(name != tplName) {
				let step = this.steps.list.findIndex(e => e.name == name);
				if(step == -1) step = 0;
				return goToNextStep.call(this, step);
			}
		},
		backButton : function() {
			let previousStep =  this.steps.index - 1;
			if(previousStep < 0) previousStep = 0;
			goToNextStep.call(this, previousStep);
		}
	},
	computed : {
		clientLogo : function(){
			var client = localStorage.getItem("client");
			return apiConf.assets + client + '/logo.png';
		},
		showBackButton : function(){
			return this.generalConf && this.steps.current && Array.isArray(this.generalConf.backable) && this.generalConf.backable.indexOf(this.steps.current) > -1;
		}
	},
	created : function() {
		//Load local conf
		let self = this, token = localStorage.getItem("Bearer"), config = localStorage.getItem("RemoteConf"), client = localStorage.getItem("client"), stepsResults = localStorage.getItem('stepsResults'), currentEvent = localStorage.getItem('currentEvent');
		this.currentSession.goToPreviouslPage = ()=>{self.backButton()};
		let now = new Date();
		if(!token || !config || !client) return logOut.call(self);

		//Restore config
		try{
			config = JSON.parse(config);
			this.storedConf = config;
			if(config.general) self.generalConf = config.general;
		}catch(e){console.log(e);return logOut.call(self);}

		//Restore current Event
		if(currentEvent){
			try{
				currentEvent = JSON.parse(currentEvent);
				self.currentSession.event = currentEvent;
			}catch(e){}
		}

		addCssSheet(client);

		//Retrieve events
		self.api.setToken(token).events().then(events => {
			let _events = self.events.concat(events);
			_events = _events.map(e => {
				if(!(e.endDate instanceof Date)) { e.endDate = new Date(e.endDate); e.endDate.setHours(23, 59, 59); }
				if(!(e.startDate instanceof Date)) { e.startDate = new Date(e.startDate);e.startDate.setHours(0, 0, 0); }
				return e;
			}).filter((e, i) => {
				return e._id && e.endDate >= now && i == events.findIndex(e2 => e2._id == e._id)
			}).map(e => {
				if(e.endDate) e.endDate = lib.dateToInput(e.endDate);
				if(e.startDate) e.startDate = lib.dateToInput(e.startDate);
				return e;
			});
			self.events = _events;
		}).catch(err => {
			console.log(err);
			logOut.call(self);
		}).finally(() => {
			if(!stepsResults) {
				if(currentEvent) return goToNextStep.call(self, 0);
				else return self.$router.push({name : 'newEvent'});
			}
			try{
				if(!currentEvent) throw new Error("Can't restore session without event");

				const templatesKey = this.steps.templatesKey;
				//Restore old results
				stepsResults = JSON.parse(stepsResults);
				self.currentSession.stepsResults = {};
				let steps = config[templatesKey].map((e,i) => e.name + '_' + i);
				Object.keys(stepsResults).forEach(k => {
					if(steps.indexOf(k) > -1) self.currentSession.stepsResults[k] = stepsResults[k];
				});
				//Route right template
				for(let _i = 0; _i < config[templatesKey].length; ++_i){
					if(config[templatesKey][_i].name && !stepsResults[config[templatesKey][_i].name + '_' + _i]) return goToNextStep.call(self, _i);
				}
				return goToNextStep.call(self, 0);
			}catch(e){console.log(e);}
		});
	},
	mounted : function(){ //called after created
		let config = localStorage.getItem("RemoteConf"), client = localStorage.getItem("client")
		try{
			config = JSON.parse(config) || {};
		}catch(e){config = {};}
		//Set custom background
		if(Array.isArray(config.assets) && client){
			config.assets.forEach(e => {
				if(e == 'pattern.svg') {
					//Update Background according to client
					let mainElement = document.getElementsByClassName('client')[0].style;
					mainElement.background = "url('"+apiConf.assets + client + "/pattern.svg') no-repeat";
					mainElement['background-size'] = 'cover';
					let overlayOrientation = document.getElementById("orientation").style;
					overlayOrientation.background = "url('"+apiConf.assets + client + "/pattern.svg') no-repeat";
					overlayOrientation['background-size'] = 'cover';
				} else if(e == 'background_top.svg') { //custom top bg
					let bg = document.getElementById("background-remote");
					if(!bg) return;
					let currentTopBg = document.getElementById("background-top");
					if(!currentTopBg) {
						let bg_top = document.createElement("img");
						bg_top.setAttribute('src', apiConf.assets + client + "/" + e);
						bg_top.setAttribute('id', 'background-top');
						bg.insertBefore(bg_top, bg.firstChild);
					} else currentTopBg.src = apiConf.assets + client + "/" + e;
				} else if(e == 'background_bottom.svg') { //custom bot bg
					let bg = document.getElementById("background-remote");
					if(!bg) return;
					let currentBotBg = document.getElementById("background-bottom");
					if(!currentBotBg) {
						let bg_bot = document.createElement("img");
						bg_bot.setAttribute('src', apiConf.assets + client + "/" + e);
						bg_bot.setAttribute('id', 'background-bottom');
						bg.appendChild(bg_bot);
					} else currentBotBg.src = apiConf.assets + client + "/" + e;
				}
			});
		}
		lib.orientation();
	}
};
</script>



// WEBPACK FOOTER //
// src/components/eventsMainTemplate.vue